const INITIAL_STATE = {
    inventoryList: {},
    lots: [],
    lotItems: [],
    lotItemsReading: [],
    lotItemsMonitoringReading: [],
    lotItem: {},
    inventory: {},
    balanceData: [],
    filter: {
        lotNumber: 0,
        lotItemNumber: 0,
        lotItemId: 0,
        inventoryId: 0,
        typeInventory: 'G',
        lotMapped: false,
        allLots: false,
        zone: undefined,
        cim: undefined,
        partNumber: undefined,
        divergent: null,
        statusInventory: null,
        validationCode: '',
        areas: [],
        streets: [],
        levels: [],
        positions: [],
        secondCount: false
    },
    logs: [],
    log: {}
};

export default function inventoryReducer(state, action) {
    if (typeof state === 'undefined') {
        return INITIAL_STATE;
    }

    switch (action.type) {
        case 'SET_LOGS':
            return {
                ...state,
                logs: action.logs,
            }
        case 'SELECT_LOG':
            return {
                ...state,
                log: action.log,
            }
        case 'LIST_INVENTORY': {
            return {
                ...state,
                inventoryList: action.inventoryList
            };
        }
        case 'SET_LOTS': {
            if (action.lots.pageIndex > state.lots.pageIndex) {
                const lotItems = [...state.lots.items, ...action.lots.items];
                action.lots.items = lotItems;
            }
            return {
                ...state,
                lots: action.lots
            };
        }
        case 'SET_LOT_ITEMS': {
            return {
                ...state,
                lotItems: action.lotItems
            };
        }
        case 'ADD_LOT_ITEMS_READING_LIST': {
            let list = Object.assign([], state.lotItemsMonitoringReading);
            if (action.item) {
                list.unshift(action.item);
            } else if (action.itemsArray?.items?.length > 0) {
                list = action.itemsArray.items;
            }

            return {
                ...state,
                lotItemsMonitoringReading: list
            };
        }
        case 'SET_LOT_ITEMS_READING': {
            return {
                ...state,
                lotItemsReading: action.lotItemsReading
            };
        }
        case 'RESET_LOTS': {
            return {
                ...state,
                lots: INITIAL_STATE.lots,
                lotItems: INITIAL_STATE.lotItems
            };
        }
        case 'INVENTORY_SELECT_TYPE': {
            const filterState = state.filter;
            filterState.typeInventory = action.typeInventory;
            return {
                ...state,
                filter: filterState
            };
        }
        case 'INVENTORY_SELECT_LOT_FILTER_ALL': {
            const filterState = state.filter;
            filterState.allLots = action.allLots;
            return {
                ...state,
                filter: filterState
            };
        }
        case 'INVENTORY_SELECT_LOT': {
            const filterState = state.filter;
            filterState.lotNumber = action.lot.lotNumber;
            filterState.inventoryId = action.lot.inventoryId;
            filterState.lotMapped = action.lot.mapped;
            return {
                ...state,
                filter: filterState
            };
        }
        case 'UPDATE_LOT_ITEMS_STATUS': {
            if (state.lotItems.items) {
                const itemUpdate = state.lotItems.items.find((m) => m.lotItemId === action.lotItem.lotItemId);
                if (itemUpdate) {
                    itemUpdate.readings = action.lotItem.readings
                    itemUpdate.status = action.lotItem.status;
                }
            }
            return state;
        }
        case 'INVENTORY_SELECT_LOT_ITEM': {
            const filterState = state.filter;
            filterState.lotItemId = action.lotItem.lotItemId;
            filterState.lotMapped = action.lotItem.mapped;

            return {
                ...state,
                filter: filterState,
                lotItem: action.lotItem
            };
        }
        case 'SET_FILTER_GENERAL': {
            const filterState = action.filter;
            return {
                ...state,
                filter: filterState,
            };
        }
        case 'INVENTORY_SELECT_INVENTORY': {
            const filterState = state.filter;
            filterState.inventoryId = action.inventory.id;
            filterState.statusInventory = action.inventory.status;
            return {
                ...state,
                inventory: action.inventory,
                filter: filterState
            };
        }
        case 'INVENTORY_REFRESH_STATUS': {
            const inventoryListState = {};
            Object.assign(inventoryListState, state.inventoryList);
            if (inventoryListState.items !== undefined) {
                const inventoryRefreshStatus = inventoryListState.items.find((i) => i.id === action.inventoryIdStatus);
                inventoryRefreshStatus.status = action.status;
            }
            return {
                ...state,
                inventoryList: inventoryListState
            };
        }
        case 'INVENTORY_REFRESH_INVENTORY': {
            const inventoryListState = {};
            const inventoryRefresh = action.inventory;
            Object.assign(inventoryListState, state.inventoryList);
            if (inventoryListState.items === undefined) {
                inventoryListState.items = [];
            }
            if (inventoryListState.items !== undefined) {
                let inventory = inventoryListState.items.find((i) => i.id === inventoryRefresh.id);
                if (inventory === undefined) {
                    inventory = inventoryRefresh;
                    inventoryListState.items.push(inventory);
                }
                inventory.status = inventoryRefresh.status;
            }
            return {
                ...state,
                inventoryList: inventoryListState

            };
        }
        case 'INVENTORY_REFRESH_LOT': {
            const inventoryListState = {};
            const inventorySelected = {};

            Object.assign(inventoryListState, state.inventoryList);
            const lotsState = [];
            Object.assign(lotsState, state.lots);
            const lot = action.lotRefresh;
            if (inventoryListState.items === undefined) {
                inventoryListState.items = [];
            }
            if (inventoryListState.items.length > 0) {
                const inventory = inventoryListState.items.find((i) => i.id === lot.inventoryId);
                if (inventory.lots === undefined) {
                    inventory.lots = [];
                }
                const lotInventory = inventory.lots.find((l) => l.lotNumber === lot.lotNumber);
                if (lotInventory !== undefined) {
                    lotInventory.status = lot.status;
                    lotInventory.startedBy = lot.startedBy;
                    lotInventory.lockedName = lot.lockedName;
                    lotInventory.lockedBy = lot.lockedBy;
                    lotInventory.lotOriginId = lot.lotOriginId;
                } else {
                    inventory.lots.push(lot);
                }

                if (state.inventory.id === inventory.id) {
                    Object.assign(inventorySelected, inventory);
                } else {
                    Object.assign(inventorySelected, state.inventory);
                }
            }
            if (lotsState.items !== undefined) {
                const lotRefresh = lotsState.items.find((i) => i.lotNumber === lot.lotNumber);
                if (lotRefresh !== undefined) {
                    lotRefresh.lotItems = lot.lotItems;
                    lotRefresh.status = lot.status;
                    lotRefresh.startedBy = lot.startedBy;
                    lotRefresh.lockedName = lot.lockedName;
                    lotRefresh.lockedBy = lot.lockedBy;
                    lotRefresh.lotOriginId = lot.lotOriginId;
                }
            }

            return {
                ...state,
                inventoryList: inventoryListState,
                lots: lotsState,
                inventory: inventorySelected
            };
        }
        case 'INVENTORY_CHANGEUSER_LOTS': {
            const inventorys = state.inventoryList;
            const inventory = inventorys.items.find((i) => i.id === action.inventory);
            return {
                ...state,
                inventory
            };
        }
        case 'INVENTORY_LOT_FILTER': {
            return {
                ...state,
                filter: action.filter,
            };
        }
        case 'RESET_FILTER_LOT': {
            const filter = state.filter;
            filter.lotItemNumber = undefined;
            filter.validationCode = undefined;
            filter.zone = undefined;
            filter.cim = undefined;
            filter.partNumber = undefined;
            filter.lotNumber = undefined;
            filter.allLots = false;
            filter.divergent = undefined;
            filter.lotOriginId = undefined;
            filter.lotItemId = undefined;
            filter.lockedBy = undefined;
            filter.startedBy = undefined;
            filter.areas = [];
            filter.streets = [];
            filter.positions = [];
            filter.levels = [];
            filter.secondCount = false;
            filter.position = undefined;
            filter.orderByPosition = undefined;
            return {
                ...state,
                filter
            };
        }
        case 'SET_BALANCE_DATA': {
            return {

                ...state,
                balanceData: action.balanceData,
            };

        }
        default:
            return state;
    }
}
